import { unitsToDecimal } from '../amount/money.js';
export function withdrawalReceipt(operation) {
    const evidence = operation.withdrawal;
    if (!evidence)
        throw new Error('offramp_evidence_missing');
    const complete = operation.status === 'delivered';
    const title = operation.status === 'submission_unknown' ||
        (evidence.cancellationRequested && operation.status === 'action_required')
        ? 'withdraw_uncertain'
        : operation.status === 'action_required' ||
            (evidence.kind === 'sell' &&
                !evidence.sendReserved &&
                evidence.expiresAt &&
                Date.parse(evidence.expiresAt) <= Date.now())
            ? 'withdraw_requote'
            : operation.status === 'refunded'
                ? 'withdraw_refunded'
                : operation.status === 'failed' || operation.status === 'cancelled'
                    ? 'withdraw_failed'
                    : complete
                        ? evidence.kind === 'sell'
                            ? 'withdraw_payout_initiated'
                            : 'withdraw_confirmed'
                        : evidence.sendReserved
                            ? 'withdraw_processing'
                            : evidence.recipient
                                ? 'withdraw_ready'
                                : 'withdraw_awaiting_instructions';
    const explorer = complete && evidence.signature
        ? `https://explorer.solana.com/tx/${encodeURIComponent(evidence.signature)}${operation.network === 'devnet' ? '?cluster=devnet' : ''}`
        : null;
    return {
        title,
        complete,
        explorer,
        amount: `${unitsToDecimal(BigInt(evidence.amountD6), 6)} USDC`,
        artwork: operation.status === 'refunded'
            ? 'refund'
            : complete
                ? 'success'
                : ['failed', 'cancelled'].includes(operation.status)
                    ? 'declined'
                    : 'processing',
        source: operation.destination,
        recipient: evidence.recipient,
        providerId: evidence.providerId,
        payoutUnits: evidence.payoutUnits,
        signature: evidence.signature,
    };
}
export function canAuthorizeWithdrawal(status, evidence, now = Date.now()) {
    return Boolean(evidence?.recipient &&
        !evidence.sendReserved &&
        !evidence.signature &&
        !evidence.cancellationRequested &&
        ['created', 'awaiting_payment'].includes(status) &&
        (evidence.kind === 'manual' || (evidence.expiresAt && Date.parse(evidence.expiresAt) > now)));
}
